<template>
  <div>
    <div>
      <button class="button is-success" @click="lauchCreate()">
        Ajouter une information
      </button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Titre</th>
          <th>Nombre de tags</th>
          <th>Nombre de fichiers / images</th>
          <th>Modification</th>
          <th>Suppression</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="info in informations" :key="info.id">
          <td>{{ info.title }}</td>
          <td>{{ info.tags.length }}</td>
          <td>{{ info.files.length }}</td>
          <td>
            <button class="button is-warning" @click="lauchUpdate(info.id)">
              Modification
            </button>
          </td>
          <td>
            <button
              class="button is-danger is-outlined"
              @click="lauchDelete(info.id)"
            >
              Suppression
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="modal" v-bind:class="{ 'is-active': isActiveModalUpdate }">
      <div class="modal-background" @click="closeUpdate"></div>

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title" v-if="infoTitle != null">
            {{ infoTitle }}
          </p>
          <p class="modal-card-title" v-if="infoTitle == null">
            Ajouter une information
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="closeUpdate"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="columns is-centered">
            <div class="column is-5-tablet is-12-desktop">
              <form @submit.prevent="submitForm" class="box">
                <div class="field">
                  <label class="label">Titre</label>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      placeholder="Titre"
                      v-model="title"
                    />
                  </div>
                </div>

                <div class="field">
                  <label class="label">Date</label>
                  <div class="control">
                    <input
                      class="input"
                      type="date"
                      placeholder="Date"
                      v-model="date"
                    />
                  </div>
                </div>

                <div class="field">
                  <label class="label">Tags</label>
                  <div class="control tags columns is-multiline">
                    <!-- checkbox -->
                    <label
                      class="checkbox column is-3"
                      v-for="tag in tags"
                      :key="tag.id"
                    >
                      <input type="checkbox" :name="tag.name" />
                      <div
                        class="box"
                        @click="updateTags(tag.name)"
                        v-bind:class="{
                          isSelected: this.infoTags.includes(tag.name),
                        }"
                      >
                        {{ tag.name }}
                      </div>
                    </label>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Images / Fichiers</label>
                  <div class="file has-name is-boxed">
                    <label class="file-label">
                      <input
                        class="file-input"
                        type="file"
                        name="resume"
                        @change="updateFiles"
                        multiple
                      />
                      <span class="file-cta">
                        <span class="file-label">
                          Choisissez un ou plusieurs fichiers
                        </span>
                      </span>
                    </label>
                  </div>
                  <div
                    class="columns is-multiline"
                    v-for="file in files"
                    :key="file"
                  >
                    <div class="box column">
                      <p>
                        {{ file.name }}
                      </p>
                      <button class="delete" @click="deleteFile(file)"></button>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Description / Message</label>
                  <div class="control">
                    <textarea
                      class="textarea"
                      placeholder="Message"
                      name="desription"
                      v-model="description"
                    ></textarea>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button is-success"
            v-if="infoTitle == null"
            @click="add()"
          >
            Ajouter cette information
          </button>
          <button
            class="button is-warning"
            v-if="infoTitle != null"
            @click="update(id)"
          >
            Confirmer les modifications
          </button>

          <button class="button" @click="closeUpdate">Cancel</button>
        </footer>
      </div>
    </div>
    <div class="modal" v-bind:class="{ 'is-active': isActiveModalDelete }">
      <div class="modal-background" @click="closeDelete"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title" v-if="infoActif.title != null">
            {{ infoActif.title }}
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="closeDelete"
          ></button>
        </header>
        <section class="modal-card-body">
          <h1>Êtes-vous certains de vouloir supprimer cette information ?</h1>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="closeDelete">Cancel</button>
          <button
            class="button is-danger"
            v-if="infoActif.title != null"
            @click="deleteEvent(infoActif.id)"
          >
            Confirmer suppression
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      type: "results",
      files: [],
      tags: [
        {
          id: 1,
          name: "Séniors A",
        },
        {
          id: 2,
          name: "Séniors B",
        },
        {
          id: 3,
          name: "Séniors C",
        },
        {
          id: 4,
          name: "U18 A",
        },
        {
          id: 5,
          name: "u18 A",
        },
        {
          id: 6,
          name: "U17",
        },
        {
          id: 7,
          name: "U15 A",
        },
        {
          id: 8,
          name: "U15 B",
        },
        {
          id: 9,
          name: "Divers",
        },
      ],
      informations: [
        {
          id: 1,
          title: "Naissance au sein du club",
          date: "2022-06-23",
          begin: "2022-06-23",
          end: "2022-06-23",
          tags: ["Séniors A", "Informations", "Divers"],
          files: ["Image 1"],
          description:
            "Féliciattaions au nouveaux parents damien et sa compagne qui ont donnée naissance à une petiter Maelle.",
        },
      ],
      isActiveModalUpdate: false,
      isActiveModalDelete: false,
      infoActif: {},
      infoTitle: null,
      id: null,
      title: null,
      date: null,
      begin: null,
      end: null,
      infoTags: [],
      infoFiles: [],
      description: null,
    };
  },
  methods: {
    updateFiles(event) {
      const filesList = event.target.files;
      for (var i = 0; i < filesList.length; i++) {
        this.files.push(filesList[i]);
      }
    },
    deleteFile(file) {
      const index = this.files.indexOf(file);
      if (index > -1) {
        this.files.splice(index, 1);
      }
    },
    updateTags(value) {
      if (this.infoTags.includes(value)) {
        const index = this.infoTags.indexOf(value);
        if (index > -1) {
          this.infoTags.splice(index, 1);
        }
      } else {
        this.infoTags.push(value);
      }
    },
    lauchCreate() {
      this.isActiveModalUpdate = true;
    },
    lauchDelete(id) {
      var proxy = { ...this.informations.find((x) => x.id == id) };
      const target_copy = Object.assign({}, proxy);
      this.infoActif = target_copy;
      this.isActiveModalDelete = true;
    },
    lauchUpdate(id) {
      var proxy = { ...this.informations.find((x) => x.id == id) };
      const target_copy = Object.assign({}, proxy);
      (this.infoTitle = target_copy.title),
        (this.id = target_copy.id),
        (this.title = target_copy.title),
        (this.date = target_copy.date),
        (this.infoTags = target_copy.tags),
        (this.infoFiles = target_copy.files),
        (this.begin = target_copy.begin),
        (this.end = target_copy.end),
        (this.description = target_copy.description);
      this.isActiveModalUpdate = true;
    },
    closeUpdate() {
      this.isActiveModalUpdate = false;
      (this.infoTitle = null),
        (this.id = null),
        (this.title = null),
        (this.date = null),
        (this.infoTags = []),
        (this.infoFiles = []),
        (this.begin = null),
        (this.end = null),
        (this.description = null);
    },
    closeDelete() {
      this.isActiveModalDelete = false;
      this.infoActif = {};
    },
    add() {},
    update() {},
    deleteEvent() {
      this.isActiveModalDelete = false;
      this.infoActif = {};
    },
  },
};
</script>
<style lang="scss">
.types {
  label {
    input {
      display: none;
    }
  }
  .isActive {
    border: 3px solid #e75913;
    border-radius: 30px;
  }
}

.tags {
  label {
    input {
      display: none;
    }
  }
  .isSelected {
    background-color: #e75913;
    color: #ffffff;
  }
}
</style>
